module.exports =(function() {
  return function(context) {
    return (function() {
      var $c, $e, $o, creator, i, j, k, len, len1, len2, ref, ref1, ref2, selected, tag, tag_group;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      $o.push("<select id='creator-id' name='creator_id' prompt='All uploaders' data-behavior='select2' data-select2options='{ \"theme\" : \"filters\", \"dropdownAutoWidth\" : true}'>\n  <option value=''>All uploaders</option>");
      ref = this.collection.creators();
      for (i = 0, len = ref.length; i < len; i++) {
        creator = ref[i];
        selected = this.collection.filters.creator_id === ("" + creator[0]);
        $o.push("  <option value='" + ($e($c(creator[0]))) + "' selected='" + ($e($c(selected))) + "' notranslate>");
        $o.push("    " + $e($c(creator[1])));
        $o.push("  </option>");
      }
      $o.push("</select>\n<select id='dimension-id' name='dimension_id' prompt='All sizes' data-behavior='select2' data-select2options='{ \"theme\" : \"filters\", \"dropdownAutoWidth\" : true}'>\n  <option value=''>All sizes</option>\n  <option value='S' selected='" + ($e($c(this.collection.filters.dimension_id === "S"))) + "'>Small</option>\n  <option value='M' selected='" + ($e($c(this.collection.filters.dimension_id === "M"))) + "'>Medium</option>\n  <option value='L' selected='" + ($e($c(this.collection.filters.dimension_id === "L"))) + "'>Large</option>\n</select>");
      if (this.collection.tags().length > 0) {
        $o.push("<select id='tag-id' name='tag_id' prompt='All tags' data-behavior='select2' data-select2options='{ \"theme\" : \"filters\", \"dropdownAutoWidth\" : true}'>\n  <option value=''>All tags</option>");
        ref1 = this.collection.tags();
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          tag_group = ref1[j];
          $o.push("  <optgroup label='" + ($e($c(tag_group.tag_group_name))) + "' notranslate>");
          ref2 = tag_group.tags;
          for (k = 0, len2 = ref2.length; k < len2; k++) {
            tag = ref2[k];
            selected = this.collection.filters.tag_id === ("" + tag[0]);
            $o.push("    <option value='" + ($e($c(tag[0]))) + "' selected='" + ($e($c(selected))) + "'>");
            $o.push("      " + $e($c(tag[1])));
            $o.push("    </option>");
          }
          $o.push("  </optgroup>");
        }
        $o.push("</select>");
      }
      $o.push("<a class='" + (['subtext', 'reset-filters', "" + ($e($c(this.collection.hasNoFilters() ? 'hidden' : void 0)))].sort().join(' ').replace(/^\s+|\s+$/g, '')) + "'>Reset filters</a>\n<div class='asset-search input-search'>\n  <input class='query' id='query' name='query' type='text' placeholder='Find your assets' value='" + ($e($c(this.collection.query))) + "' autocomplete='off'>\n  <div class='icon icon-search'></div>\n  <span class='hidden icon icon-times-circle js-clear-search'></span>\n</div>");
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./app/javascript/backbone/platform/templates/assets/assets_filters.js.hamlc
// module id = 1565
// module chunks = 18